/* @flow */

import * as React from 'react';
import ReactTooltip from 'react-tooltip';

import classnames from 'classnames';

import {CloseIcon} from '../../icon';

import './close-button.module.css';

type Props = {|
    size?: number,
    className?: string,
    tooltip?: string,
    getRef?: (?HTMLButtonElement) => void,
    onClick?: (e: SyntheticEvent<*>) => void,
    variant?: 'dark' | 'medium' | 'light',
    alignCenter?: boolean,
    onPointerDown?: (e: SyntheticEvent<*>) => void,
|};

export function CloseButton(props: Props) {
    const {size = 14, variant = 'medium'} = props;

    React.useEffect(() => {
        ReactTooltip.rebuild();

        return () => {
            ReactTooltip.hide();
        };
    }, []);

    const containerStyles = classnames('container', {
        'container--light': variant === 'light',
        'container--medium': variant === 'medium',
        'container--dark': variant === 'dark',
    });

    return (
        <button
            type='button'
            onClick={props.onClick}
            ref={props.getRef}
            data-tip={props.tooltip}
            className={props.className}
            styleName={containerStyles}
            onPointerDown={props.onPointerDown}
        >
            <CloseIcon size={size} alignCenter={Boolean(props.alignCenter)} />
        </button>
    );
}
